import AddedItemsToCart from './AddedItemsToCart'

export default AddedItemsToCart
